import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';

import Api from '../../api'
                
class menu extends Component {
  logout() {
    var api = new Api()
    api.unmount()
    api.jump('/')
  }


  render() {
  	var api = new Api();

    return (
      <Row className="subheader" style={{margin:"5px"}}>
                      {!api.valid() ? <Col sm="1" className="text-center"></Col> : ""}
                      <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
                        <NavLink className="inline-link" href="/">
                          <Button className="px-4 btn-outline" color="primary">Home</Button>
                        </NavLink>
                      </Col>
                      {api.valid() ? (
	                      <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
	                        <NavLink className="inline-link" href="/list">
	                          <Button className="px-4 btn-outline" color="primary">My Contacts</Button>
	                        </NavLink>
	                      </Col>
                      ) : (
						          <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
	                        <NavLink className="inline-link" href="/login">
	                          <Button className="px-4 btn-outline" color="primary">Login</Button>
	                        </NavLink>
	                      </Col>
                      )}
                      {api.valid() ? (
	                      <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
	                        <NavLink className="inline-link" href="/changepw">
	                        <Button className="px-4 btn-outline" color="primary">My Settings</Button>
	                        </NavLink>
	                      </Col>
                      ) : (
	                      <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
	                        <NavLink className="inline-link" href="/register">
	                        <Button className="px-4 btn-outline" color="primary">Register</Button>
	                        </NavLink>
	                      </Col>
                      )}
                      <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
                        <NavLink className="inline-link" href="/help">
                        <Button className="px-4 btn-outline" color="primary">Help</Button>
                        </NavLink>
                      </Col>
                      <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}}>
                        <NavLink className="inline-link" href="/contact">
                        <Button className="px-4 btn-outline" color="primary">Contact</Button>
                        </NavLink>
                      </Col>
                      {!api.valid() ? <Col sm="1" className="text-center"></Col> : <Col sm="2" className="text-center" style={{paddingLeft:0,paddingRight:0}} onClick={this.logout.bind(this)}><Button className="px-4 btn-outline" color="primary">Log-Out</Button></Col>}
                    </Row>
    )
  }
}

export default menu;


// WEBPACK FOOTER //
// ./src/views/Common/menu.js